import Component from 'vue-class-component'
import Vue from 'vue'
import Tags from '../shared/Tags.vue'
import convoStore from '../../store/convo/convo-store'
import authStore from '../../store/auth/auth-store'

@Component({
  name: 'convoTags',
  props: ['convo', 'isEditable'],
  components: { 'tags' : Tags }
})
export default class ConvoTags extends Vue {

  protected addConvoTag (): void {
    convoStore.dispatchAddConvoTag(this.$props['convo'])
  }

  protected removeConvoTag (tag: string): void {
    convoStore.dispatchRemoveConvoTag({ convo: this.$props['convo'], tag: tag })
  }

}
